/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Latestreleased_Title1Inputs */

const id_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbaru Dirilis`)
};

const ms_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terkini Dikeluarkan`)
};

const da_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senest Udgivet`)
};

const de_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste Veröffentlichung`)
};

const en_us2_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Released`)
};

const es_es2_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos lanzamientos`)
};

const es_mx2_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzados recientemente`)
};

const fil_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pinakabagong Nailabas`)
};

const fr_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernières sorties`)
};

const it_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi rilasciati`)
};

const hu_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legutóbb megjelent`)
};

const nl_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent uitgebracht`)
};

const no_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nylig utgitt`)
};

const pl_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnio wydane`)
};

const pt_br2_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Released`)
};

const pt_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançados recentemente`)
};

const ro_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansate recent`)
};

const fi_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi julkaistut`)
};

const sv_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast släppta`)
};

const vi_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát hành mới nhất`)
};

const tr_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Çıkanlar`)
};

const cs_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naposledy vydané`)
};

const bg_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последно издадени`)
};

const ru_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние выпущенные`)
};

const uk_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні релізи`)
};

const ar_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر الإصدارات`)
};

const hi_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम रिलीज़`)
};

const th_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล่าสุดที่วางจำหน่าย`)
};

const ja_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新リリース`)
};

const zh_cn2_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Released`)
};

const zh_hant1_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Released`)
};

const ko_components_latestreleased_title1 = /** @type {(inputs: Components_Latestreleased_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Released`)
};

/**
* | output |
* | --- |
* | "Latest Released" |
*
* @param {Components_Latestreleased_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_latestreleased_title1 = /** @type {((inputs?: Components_Latestreleased_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Latestreleased_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_latestreleased_title1(inputs)
	if (locale === "ms") return ms_components_latestreleased_title1(inputs)
	if (locale === "da") return da_components_latestreleased_title1(inputs)
	if (locale === "de") return de_components_latestreleased_title1(inputs)
	if (locale === "en-US") return en_us2_components_latestreleased_title1(inputs)
	if (locale === "es-ES") return es_es2_components_latestreleased_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_latestreleased_title1(inputs)
	if (locale === "fil") return fil_components_latestreleased_title1(inputs)
	if (locale === "fr") return fr_components_latestreleased_title1(inputs)
	if (locale === "it") return it_components_latestreleased_title1(inputs)
	if (locale === "hu") return hu_components_latestreleased_title1(inputs)
	if (locale === "nl") return nl_components_latestreleased_title1(inputs)
	if (locale === "no") return no_components_latestreleased_title1(inputs)
	if (locale === "pl") return pl_components_latestreleased_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_latestreleased_title1(inputs)
	if (locale === "pt") return pt_components_latestreleased_title1(inputs)
	if (locale === "ro") return ro_components_latestreleased_title1(inputs)
	if (locale === "fi") return fi_components_latestreleased_title1(inputs)
	if (locale === "sv") return sv_components_latestreleased_title1(inputs)
	if (locale === "vi") return vi_components_latestreleased_title1(inputs)
	if (locale === "tr") return tr_components_latestreleased_title1(inputs)
	if (locale === "cs") return cs_components_latestreleased_title1(inputs)
	if (locale === "bg") return bg_components_latestreleased_title1(inputs)
	if (locale === "ru") return ru_components_latestreleased_title1(inputs)
	if (locale === "uk") return uk_components_latestreleased_title1(inputs)
	if (locale === "ar") return ar_components_latestreleased_title1(inputs)
	if (locale === "hi") return hi_components_latestreleased_title1(inputs)
	if (locale === "th") return th_components_latestreleased_title1(inputs)
	if (locale === "ja") return ja_components_latestreleased_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_latestreleased_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_latestreleased_title1(inputs)
	return ko_components_latestreleased_title1(inputs)
});
export { components_latestreleased_title1 as "components.latestReleased.title" }